module.exports = __webpack_public_path__ + "static/media/icone-reparo-modal.726e0725.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/icone-reparo-modal.svg
// module id = 120
// module chunks = 0